import "@stimulus/polyfills"
// import * as Turbo from "@hotwired/turbo"
import { Application } from 'stimulus'
import FormController from './controllers/FormController'
import CarouselController from './controllers/CarouselController'
import HeaderController from "./controllers/HeaderController"
import HeroanimationController from "./controllers/HeroanimationController"
import ParallaximageController from "./controllers/ParallaximageController"
import FiltersliderController from "./controllers/FiltersliderController"
import DropdownController from "./controllers/DropdownController"
import GalleryController from "./controllers/GalleryController"
import LazyloadingController from "./controllers/LazyloadingController"
import OverlayController from "./controllers/OverlayController"

// Initialize turbo.
// Turbo.start()

// Initialize stimulus.
const application = Application.start()
application.register('form', FormController)
application.register('carousel', CarouselController)
application.register('header', HeaderController)
application.register('heroanimation', HeroanimationController)
application.register('parallaximage', ParallaximageController)
application.register('filterslider', FiltersliderController)
application.register('dropdown', DropdownController)
application.register('gallery', GalleryController)
application.register('lazyloading', LazyloadingController)
application.register('overlay', OverlayController)

// Manage load completed event.
window.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('js')
})
